import { render, staticRenderFns } from "./deleteTemplateConfirmDialog.vue?vue&type=template&id=74327a8e&scoped=true&lang=pug"
import script from "./deleteTemplateConfirmDialog.vue?vue&type=script&lang=js"
export * from "./deleteTemplateConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./deleteTemplateConfirmDialog.vue?vue&type=style&index=0&id=74327a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74327a8e",
  null
  
)

export default component.exports